import { Autocomplete, TextField } from '@mui/material';
import { FieldInputProps } from 'formik';
import * as React from 'react';
import { IFormField, ISelectOption } from '.';

interface MultiselectProps {
  item: IFormField;
  t: any;
  e: any;
  fieldProps: FieldInputProps<any>;
  fieldCallback: any;
}

export default function MFormMultiselect({
  item,
  t,
  e,
  fieldProps,
  fieldCallback
}: MultiselectProps) {
  const { name, disabled, options = [], label, dependentFields, handleChange, ...rest } = item;

  const [selected, setSelected] = React.useState<any>([]);

  const { value } = fieldProps;

  React.useEffect(() => {
    if (value) {
      const defaultOptions: ISelectOption[] = options.filter((el: ISelectOption) =>
        value.some((f: number) => f === el.value)
      );
      setSelected(defaultOptions);
    }
  }, [value, options]);

  return options ? (
    <Autocomplete
      multiple
      id={name}
      value={selected}
      key={`auto-complete-${name}`}
      options={options}
      disabled={disabled}
      disableCloseOnSelect
      filterSelectedOptions
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, e) => option.value === e.value}
      renderInput={(params) => {
        params.InputProps['data-testid'] = name;
        return (
          <TextField
            {...params}
            {...rest}
            error={Boolean(t && e)}
            helperText={t && e}
            label={label}
          />
        );
      }}
      onChange={(event: React.ChangeEvent<HTMLInputElement>, newValue: ISelectOption[]) => {
        setSelected(newValue);
        fieldCallback(item, newValue, dependentFields);
        if (handleChange) handleChange(newValue);
      }}
    />
  ) : (
    <React.Fragment key={`react-fragment-${name}`} />
  );
}
